import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInputReference = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 12,
	viewBox: "0 0 10 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 3.84H8.432L9.088 0.608H7.552L6.896 3.84H4.544L5.2 0.608H3.664L3.008 3.84H1.456L1.184 5.168H2.736L2.272 7.44H0.72L0.448 8.768H2L1.344 12H2.88L3.536 8.768H5.888L5.232 12H6.768L7.424 8.768H8.992L9.264 7.44H7.696L8.16 5.168H9.728L10 3.84ZM3.808 7.44L4.272 5.168H6.624L6.16 7.44H3.808Z",
		fill: "black"
	})
});
export default SvgInputReference;
